import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../../components/elements/LoadingButton";
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import {connect, setStore} from "trim-redux";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import ChooseExpireDate from "../../../components/elements/ChooseExpireDate";
import Alert from "@material-ui/lab/Alert/Alert";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";

import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import {currencySymbol} from "../../../../config/values";
class MakeShopDiscount extends React.Component {

    constructor(props){
        super(props);
        this.ThumbChild = React.createRef();
        this.EditorChild = React.createRef();

    }
    state = {
        fields:{
            name:"",
            type:"percent",
            value:"",
            expired_at:"",
            expired_at_def:"",
            total_count:"",
            count:"",
            decrease_from:"both",
        },
        active:true,
        errors:{},
        loading: false,
        SubmitLoading: false,
        id:this.props.match.params.id,
        editMode:false,
        categories:[],
        defaultCategory:null,
        category_id:null,
        shops:[],
        defaultShop:null,
        shop_id:null,
    };
    classes = this.props.classes;
    async componentDidMount(){
        if(!!this.state.id){
            this.setState({
                editMode:true,
                loading:true,
            })
            await this.loadData();
        }
        await this.loadDefaults();

    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    async loadDefaults(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.get(`${defaultVariabls.url}/parent-categories/quickViewForChooser`, config)
            .then(response => {
                let categories = response.data;
                categories.map((item,index) =>{
                    return item.id === this.state.category_id ? this.setState({
                        defaultCategory: index,
                    }) : null
                })
                this.setState({
                    categories: response.data,
                })
            })
            .catch(error => {
                this.setState({
                    loading:false,
                    SubmitLoading:false
                })
            })
        await axios.get(`${defaultVariabls.url}/shops/quickViewForChooser`, config)
            .then(response => {
                console.log(response.data)
                let shops = response.data;
                shops.map((item,index) =>{
                    return item.id === this.state.shop_id ? this.setState({
                        defaultShop: index,
                    }) : null
                })
                this.setState({
                    shops: response.data,
                    loading:false
                })
            })
            .catch(error => {
                this.setState({
                    loading:false,
                    SubmitLoading:false
                })
            })
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/shop-discount/get/${this.state.id}`, config)
                .then(response => {
                    this.setState({
                        fields: {
                            name: response.data.name,
                            type: response.data.type,
                            value: response.data.value,
                            expired_at: response.data.expired_at,
                            expired_at_def: response.data.expired_at,
                            total_count: response.data.total_count,
                            count: response.data.count,
                            decrease_from: response.data.decrease_from,
                        },
                        active: parseInt(response.data.active),
                        category_id: response.data.category_id,
                        shop_id: response.data.shop_id,
                    })

                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        if(target.name === "name"){
            fields[target.name] = target.value.replace(/\s+/g, '');
        }else{
            fields[target.name] = target.value;
        }
        errors[target.name] = "";
        this.setState({fields});
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(!fields.name){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }
        //name
        if(!fields.value){
            formIsValid = false;
            errors['value'] = Translate.emptyField;
        }
        //name
        if(fields.type === "percent"){
            if(fields.value > 100){
                formIsValid = false;
                errors['value'] = Translate.cantBeMoreThan100;
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { fields,id,editMode,active,category_id} = this.state;
        let {user} = this.props;
        let shop_id = !!user.shops ? !!user.shops[0] ? user.shops[0].id : 0 : 0;
        let data = new FormData();
        data.append('name', fields.name);
        data.append('type', fields.type);
        data.append('value', fields.value);
        data.append('expired_at', fields.expired_at);
        data.append('total_count', fields.total_count);
        data.append('count', fields.count);
        data.append('id', id ? id : 0);
        data.append('description', fields.description);
        data.append('decrease_from', fields.decrease_from);
        data.append('category_id', category_id);
        data.append('shop_id', shop_id);
        data.append('active',  active ? 1 : 0);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/shop-discount/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.dataEdited : Translate.dataAdded, {
                    variant: 'success',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
                if(!this.state.editMode){
                    this.props.history.push(`/vendor/discounts`);
                }
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(editMode ?  Translate.dataEditingFailed : Translate.dataAddingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }

    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleExpiredDate(date){
        let {fields} = this.state;
        fields.expired_at = date;
        this.setState({
            fields
        })
    }
    handleChangeActive(){
        this.setState({
            active: !this.state.active,
        })
    }
    handleCategory(value){
        if(value === null){
            this.setState({
                category_id:''
            })
        }else{
            this.setState({
                category_id:value.id
            })
        }
    }
    handleShop(value){
        if(value === null){
            this.setState({
                shop_id:''
            })
        }else{
            this.setState({
                shop_id:value.id
            })
        }
    }
    render(){
        let {fields, errors,SubmitLoading,editMode,active,categories,shops} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={editMode ? Translate.editDiscount : Translate.makeDiscount}>
            {

                        <Grid container spacing={2} justify="center">
                            <Grid item xs={12} md={11} lg={10}>
                                <AppCard
                                    title={editMode ? Translate.editDiscount : Translate.makeDiscount}
                                    action={
                                        <BreadCrumbs singleLevel firstText={editMode ? Translate.editDiscount : Translate.makeDiscount}/>
                                    }>
                                    {
                                        this.state.loading ? <AppCardLoaderFields/> :
                                            <Grid container spacing={2} >
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        variant="outlined"
                                                        name="name"
                                                        label={Translate.discount_code}
                                                        type="text"
                                                        id="name"
                                                        value={fields.name}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['name']}
                                                        helperText={errors['name']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} className="expired_at">
                                                    <ChooseExpireDate
                                                        size="medium"
                                                        input={fields.expired_at_def}
                                                        handleDate={this.handleExpiredDate.bind(this)}
                                                        label={Translate.discount_expired_at}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        variant="outlined"
                                                        name="type"
                                                        label={Translate.discount_type}
                                                        type="text"
                                                        value={fields.type}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['type']}
                                                        helperText={errors['type']}
                                                        select
                                                    >
                                                        <MenuItem value="percent">
                                                            {Translate.percent}
                                                        </MenuItem>
                                                        <MenuItem value="fixed">
                                                            {Translate.fixed}
                                                        </MenuItem>
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        variant="outlined"
                                                        name="value"
                                                        label={Translate.discount_value}
                                                        type="number"
                                                        value={fields.value}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['value']}
                                                        helperText={errors['value']}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    {fields.type === "percent" ? "%" : currencySymbol}
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        variant="outlined"
                                                        name="total_count"
                                                        label={Translate.discount_total_count}
                                                        type="number"
                                                        value={fields.total_count}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['total_count']}
                                                        helperText={errors['total_count']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        margin="normal"
                                                        fullWidth
                                                        variant="outlined"
                                                        name="count"
                                                        label={Translate.discount_count}
                                                        type="number"
                                                        value={fields.count}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['count']}
                                                        helperText={errors['count']}
                                                        disabled
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Autocomplete
                                                        options={categories}
                                                        defaultValue={categories[this.state.defaultCategory]}
                                                        onChange={(event, value) => this.handleCategory(value)}
                                                        getOptionLabel={option => option.name}
                                                        renderInput={params => (
                                                            <TextField
                                                                margin="normal"
                                                                {...params}
                                                                label={Translate.chooseCategory}
                                                                variant="outlined"
                                                                fullWidth
                                                                helperText={Translate.categoryDiscountHelp}
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Alert
                                                        severity="info"
                                                        action={
                                                            <FormControlLabel
                                                                style={{marginRight:10}}
                                                                control={
                                                                    <Switch
                                                                        checked={active}
                                                                        onChange={this.handleChangeActive.bind(this)}
                                                                        value={active}
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={active ? Translate.active : Translate.inactive}
                                                            />
                                                        }
                                                    >
                                                        {Translate.activityStatus}
                                                    </Alert>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <LoadingButton
                                                        variant="contained"
                                                        color="primary"
                                                        onClick = {this.handleSubmit.bind(this)}
                                                        loading = {SubmitLoading}
                                                    >
                                                        {editMode ? Translate.editDiscount : Translate.makeDiscount}
                                                    </LoadingButton>
                                                </Grid>
                                            </Grid>
                                    }
                                </AppCard>
                            </Grid>
                        </Grid>
                }
            </AppAnimate>

        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MakeShopDiscount))));
